import { render, staticRenderFns } from "./InspectionTaskTransfer.vue?vue&type=template&id=9b3a0262"
import script from "./InspectionTaskTransfer.vue?vue&type=script&lang=js"
export * from "./InspectionTaskTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports